import type { AxiosRequestConfig } from 'axios'
import type { AccessState, User } from '@/types/user-type'
import { api } from './axios-client'

type AuthRequestConfig = AxiosRequestConfig & {
  meta?: { skipAuthRefresh?: boolean }
}

export const getCurrentUser = async (
  config?: AuthRequestConfig,
): Promise<User> => {
  const response = await api.get<User>(`user/me`, config)
  if (response.accessState) {
    response.accessState = response.accessState.toLowerCase() as AccessState
  }
  return response
}

export const logoutUser = async (): Promise<void> => {
  await api.post<void>('auth/logout')
}

let pendingAuthenticate: Promise<{ redirectUrl: string }> | null = null

export type AuthenticationHints = {
  loginHint?: string
  screenHint?: 'sign-up'
}

export const initiateAuthentication = async (
  redirectUrl: string,
  forceLoginOrHints: boolean | AuthenticationHints = false,
  maybeHints?: AuthenticationHints,
): Promise<{ redirectUrl: string }> => {
  const forceLogin =
    typeof forceLoginOrHints === 'boolean' ? forceLoginOrHints : false
  const hints =
    typeof forceLoginOrHints === 'boolean' ? maybeHints : forceLoginOrHints

  if (pendingAuthenticate) return pendingAuthenticate
  pendingAuthenticate = api
    .post<{ redirectUrl: string }>('auth/authenticate', {
      redirectUrl,
      forceLogin,
      ...(hints?.loginHint ? { loginHint: hints.loginHint } : {}),
      ...(hints?.screenHint ? { screenHint: hints.screenHint } : {}),
    })
    .finally(() => {
      pendingAuthenticate = null
    })
  return pendingAuthenticate
}
